<mat-list class="no-padding">
  <mat-list-item (click)="openLink($event); logOut();">
    <mat-icon matListItemIcon class="margin-16">power_settings_new</mat-icon>
    <div matListItemTitle>Se déconnecter</div>
  </mat-list-item>    
</mat-list>